import { CheckboxIcon } from '@app/components/icons/checkbox';
import cx from 'classnames';
import React from 'react';

type CheckboxProps = {
  name: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  'aria-describedby'?: string;
} & React.InputHTMLAttributes<HTMLInputElement>;

export const Checkbox: React.FC<CheckboxProps> = ({
  name,
  onChange,
  checked,
  ...props
}) => {
  return (
    <div className="relative w-5 h-5">
      <input
        type="checkbox"
        className={cx(
          'peer absolute inset-0 h-auto cursor-pointer appearance-none !border-none !shadow-none bg-transparent z-10',
          'outline-none ui-focus-visible:ring-2 ui-focus-visible:ring-blue-500 ui-focus-visible:ring-offset-2 ui-focus-visible:ring-offset-spring-neutral-base',
          'disabled:cursor-not-allowed',
        )}
        name={name}
        onChange={onChange}
        checked={checked}
        {...props}
      />
      <div
        className={cx('absolute inset-0 flex items-center justify-center', {
          'border border-spring-neutral-b3 rounded': !checked,
          'border-none bg-spring-primary rounded': checked,
        })}
      >
        <CheckboxIcon
          className={cx('h-3 w-3 m-auto text-white stroke-white stroke-2', {
            'opacity-0': !checked,
            'opacity-100': checked,
          })}
          aria-hidden="true"
        />
      </div>
    </div>
  );
};
